import request from '@/utils/request';

export function getCurrentAmount(params) {
  return request({
    url: 'v1/promo/getCurrentAmount',
    method: 'get',
    params,
  });
}

export function setAmount(data) {
  return request({
    url: 'v1/promo/setAmount',
    method: 'post',
    data,
  });
}
